/* eslint-disable no-unused-vars */

/*
 * =====================
 * Brand Colour Palette
 * =====================
 */

/*
 * Primary Brand Colours
 */

// Navy
const COLOR_NAVY_100 = '#143059';
const COLOR_NAVY_80 = '#43597A';
const COLOR_NAVY_60 = '#72839B';
const COLOR_NAVY_40 = '#A1ACBD';
const COLOR_NAVY_20 = '#D0D6DE';
const COLOR_NAVY_10 = '#E8EAEE';

// Red
const COLOR_RED_100 = '#BA3038';
const COLOR_RED_80 = '#C85A60';
const COLOR_RED_60 = '#D68388';
const COLOR_RED_40 = '#E3ACAF';
const COLOR_RED_20 = '#F1D6D7';
const COLOR_RED_10 = '#F8EAEB';

// Yellow
const COLOR_YELLOW_100 = '#FBAA19';
const COLOR_YELLOW_80 = '#FCBB47';
const COLOR_YELLOW_60 = '#FCCC75';
const COLOR_YELLOW_40 = '#FDDDA3';
const COLOR_YELLOW_20 = '#FEEED1';
const COLOR_YELLOW_10 = '#FFF6E8';

/*
 * Secondary Brand Colours
 */

// Blue
const COLOR_BLUE_100 = '#2F6B9A';
const COLOR_BLUE_80 = '#5989AE';
const COLOR_BLUE_60 = '#82A6C2';
const COLOR_BLUE_40 = '#ACC4D7';
const COLOR_BLUE_20 = '#D5E1EB';
const COLOR_BLUE_10 = '#EAF0F5';

// Green
const COLOR_GREEN_100 = '#28863E';
const COLOR_GREEN_80 = '#539E65';
const COLOR_GREEN_60 = '#7EB68B';
const COLOR_GREEN_40 = '#A9CFB2';
const COLOR_GREEN_20 = '#D4E7D8';
const COLOR_GREEN_10 = '#EAF3EC';

// Orange
const COLOR_ORANGE_100 = '#F36F21';
const COLOR_ORANGE_80 = '#F58C4D';
const COLOR_ORANGE_60 = '#F8A97A';
const COLOR_ORANGE_40 = '#FAC6A6';
const COLOR_ORANGE_20 = '#FDE2D3';
const COLOR_ORANGE_10 = '#FEF1E9';

// Purple
const COLOR_PURPLE_100 = '#543D80';
const COLOR_PURPLE_80 = '#766499';
const COLOR_PURPLE_60 = '#988BB3';
const COLOR_PURPLE_40 = '#BBB1CC';
const COLOR_PURPLE_20 = '#DDD8E6';
const COLOR_PURPLE_10 = '#EEECF2';

/*
 * Neutral Brand Colours
 */

// Black
const COLOR_BLACK_100 = '#241F21';
const COLOR_BLACK_80 = '#504C4D';
const COLOR_BLACK_60 = '#7C797A';
const COLOR_BLACK_40 = '#A7A5A6';
const COLOR_BLACK_20 = '#D3D2D3';
const COLOR_BLACK_10 = '#E9E9E9';

// Dark Grey
const COLOR_DARKGREY_100 = '#5B6063';
const COLOR_DARKGREY_80 = '#7C8082';
const COLOR_DARKGREY_60 = '#9DA0A1';
const COLOR_DARKGREY_40 = '#BDBFC1';
const COLOR_DARKGREY_20 = '#DEDFE0';
const COLOR_DARKGREY_10 = '#EFEFEF';

// Medium Grey
const COLOR_MEDIUMGREY_100 = '#B6B2B0';
const COLOR_MEDIUMGREY_80 = '#C5C1C0';
const COLOR_MEDIUMGREY_60 = '#D3D1D0';
const COLOR_MEDIUMGREY_40 = '#E2E0DF';
const COLOR_MEDIUMGREY_20 = '#F0F0EF';
const COLOR_MEDIUMGREY_10 = '#F8F7F7';

// Light Grey
const COLOR_LIGHTGREY_100 = '#E3DDD8';
const COLOR_LIGHTGREY_80 = '#E9E4E0';
const COLOR_LIGHTGREY_60 = '#EEEBE8';
const COLOR_LIGHTGREY_40 = '#F4F1EF';
const COLOR_LIGHTGREY_20 = '#F9F8F7';
const COLOR_LIGHTGREY_10 = '#FCFCFB';

// White
const COLOR_WHITE = '#FFF';

export default {
  colorPageBackground: COLOR_WHITE,
  colorComponentBackgroundBase: COLOR_LIGHTGREY_100,
  colorComponentBackgroundDark: COLOR_MEDIUMGREY_20,
  colorOverlayBackground: COLOR_BLACK_100,
  colorCopy: COLOR_BLACK_100,
  colorCopyLight: COLOR_DARKGREY_100,
  colorBorder: COLOR_MEDIUMGREY_80,
  colorLink: COLOR_BLUE_100,
  colorLinkHover: COLOR_BLUE_80,
  colorSuccess: COLOR_GREEN_100,
  colorWarning: COLOR_YELLOW_100,
  colorError: COLOR_RED_100,
  colorAlert: COLOR_RED_100,
  
  // Brand
  colorBase: COLOR_BLACK_100,
  colorPrimary: COLOR_BLUE_100,

  // Mobile Nav
  colorMobileNavBackground: COLOR_WHITE,
  colorMobileNavBackgroundActive: COLOR_LIGHTGREY_20,

  // Buttons
  colorBtnWhite: COLOR_WHITE,
  colorPrimaryBtn: COLOR_GREEN_100,
  colorPrimaryHoverBtn: '#227235',
  colorSecondaryBtn: COLOR_NAVY_100,

  // Social
  colorTwitterCopy: COLOR_WHITE,
  colorTwitterFill: '#55acee',
  colorFacebookCopy: COLOR_WHITE,
  colorFacebookFill: '#3b5998',
  colorGoogleCopy: COLOR_WHITE,
  colorGoogleFill: '#df4a32',
  colorLinkedinCopy: COLOR_WHITE,
  colorLinkedinFill: '#1c87bd',
  colorYoutubeCopy: COLOR_WHITE,
  colorYoutubeFill: '#cd201f',
  colorInstagramCopy: COLOR_WHITE,
  colorInstagramFill: '#3f729b',
  colorFlickrCopy: COLOR_WHITE,
  colorFlickrFill: '#1057ae',
  colorTumblrCopy: COLOR_WHITE,
  colorTumblrFill: '#35465c',
  colorPinterestCopy: COLOR_WHITE,
  colorPinterestFill: '#bd081c',
};
